import { DenovoIcon, Typography } from "@repo/design-system";

export function DetailsPageError() {
  return (
    <div className="flex min-h-screen flex-col bg-backgroundPrimary p-8 pt-16 md:pt-24">
      <div className="mx-auto w-full max-w-7xl">
        <div className="flex flex-col items-center justify-center gap-3 rounded-xl border border-borderPrimary bg-backgroundSecondary py-16">
          <DenovoIcon
            icon="info-circle"
            width={40}
            height={40}
            className="text-contentTertiary"
          />
          <Typography
            variant="paragraph-l-medium"
            className="text-contentSecondary">
            No compound data available
          </Typography>
        </div>
      </div>
    </div>
  );
}
